import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  AdminsApi,
  AdminsJobBoardsVacanciesGetJobVacancyListResponseItem,
  Configuration,
  OrderDirectionEnum,
} from 'generated/api'
import { categoryJobVacanciesEnum, sortFieldJobVacanciesEnum } from './jobVacancyEnum'
import { axiosDefaultConfig } from 'constants/axios'
import Toast from 'components/toast/Toast'

const axiosConfig = new Configuration(axiosDefaultConfig)
const adminsApi = new AdminsApi(axiosConfig)

export const useJobVacancies = (shouldFetchOnMountFetchJobVacancies = true) => {
  const { toast, toastContainer } = Toast()
  const navigate = useNavigate()
  const [fetchStatusJobVacancies, setFetchStatusJobVacancies] = useState<
    'loading' | 'idle' | 'error'
  >('idle')
  const [jobVacancies, setJobVacancies] = useState<
    AdminsJobBoardsVacanciesGetJobVacancyListResponseItem[]
  >([])

  const [pageJobVacancies, setPageJobVacancies] = useState(1)
  const [limitJobVacancies, setLimitJobVacancies] = useState(10)
  const [totalPageJobVacancies, setTotalPageJobVacancies] = useState(1)
  const [sortFieldJobVacancies, setSortFieldJobVacancies] = useState<sortFieldJobVacanciesEnum>(
    sortFieldJobVacanciesEnum.CREATEDATUTC0,
  )
  const [sortDirectionJobVacancies, setSortDirectionJobVacancies] = useState<OrderDirectionEnum>(
    OrderDirectionEnum.Desc,
  )
  const [selectedCategoryJobVacancy, setSelectedCategoryJobVacancy] =
    useState<categoryJobVacanciesEnum>(categoryJobVacanciesEnum.DEFAULT)
  const [searchValueJobVacancies, setSearchValueJobVacancies] = useState('')

  useEffect(() => {
    if (shouldFetchOnMountFetchJobVacancies) fetchJobVacancies()
  }, [
    pageJobVacancies,
    limitJobVacancies,
    sortFieldJobVacancies,
    sortDirectionJobVacancies,
    selectedCategoryJobVacancy,
  ])

  const fetchJobVacancies = async () => {
    try {
      setFetchStatusJobVacancies('loading')
      const {
        data: { items, pagination },
      } = await adminsApi.adminsJobBoardsVacanciesGetJobVacancyList(
        pageJobVacancies,
        limitJobVacancies,
        sortFieldJobVacancies,
        sortDirectionJobVacancies,
        selectedCategoryJobVacancy ? selectedCategoryJobVacancy : undefined,
        searchValueJobVacancies ? searchValueJobVacancies : undefined,
      )
      setFetchStatusJobVacancies('idle')
      setJobVacancies(items)
      setTotalPageJobVacancies(pagination.pages)
    } catch {
      setFetchStatusJobVacancies('error')
    }
  }

  const handleOnChangeLimitJobVacancies = (updatedLimit: number) => {
    setLimitJobVacancies(updatedLimit)
    setPageJobVacancies(1)
  }

  const handleOnChangePageJobVacancies = (updatedPage: number) => {
    setPageJobVacancies(updatedPage)
  }

  const handleOnChangeSearchValueJobVacancies = (updatedSearchValue: string) => {
    setSearchValueJobVacancies(updatedSearchValue)
  }

  const handleOnEnterSearchValueJobVacancies = () => {
    pageJobVacancies === 1 ? fetchJobVacancies() : setPageJobVacancies(1)
  }

  const handleOnChangeSelectedCategoryJobVacancies = (
    updatedCategory: categoryJobVacanciesEnum,
  ) => {
    setSelectedCategoryJobVacancy(updatedCategory)
    setPageJobVacancies(1)
  }

  const handleOnChangeSort = (updatedField: sortFieldJobVacanciesEnum) => {
    if (updatedField === sortFieldJobVacancies) {
      setSortDirectionJobVacancies(
        sortDirectionJobVacancies === OrderDirectionEnum.Asc
          ? OrderDirectionEnum.Desc
          : OrderDirectionEnum.Asc,
      )
    } else {
      setSortFieldJobVacancies(updatedField)
      setSortDirectionJobVacancies(OrderDirectionEnum.Desc)
    }
  }

  const handleOnNavigateToDetail = (id: string) => {
    navigate(`/job-vacancy/${id}`)
  }

  const handleOnNavigateToCreate = () => {
    navigate('/job-vacancy/create')
  }

  return {
    toast,
    toastContainer,
    fetchStatusJobVacancies,
    jobVacancies,
    pageJobVacancies,
    limitJobVacancies,
    totalPageJobVacancies,
    sortFieldJobVacancies,
    sortDirectionJobVacancies,
    selectedCategoryJobVacancy,
    searchValueJobVacancies,
    fetchJobVacancies,
    handleOnChangeLimitJobVacancies,
    handleOnChangePageJobVacancies,
    handleOnChangeSearchValueJobVacancies,
    handleOnEnterSearchValueJobVacancies,
    handleOnChangeSelectedCategoryJobVacancies,
    handleOnChangeSort,
    handleOnNavigateToDetail,
    handleOnNavigateToCreate,
  }
}
